var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'phone')?_c('div',{staticClass:"cursor-pointer",on:{"click":_vm.copyPhone}},[_vm._t("default")],2):(_vm.type === 'link')?_c('a',{staticClass:"text-decoration-none",attrs:{"target":"_self"}},[_vm._t("default")],2):(_vm.type === 'email')?_c('a',{staticClass:"text-decoration-none",attrs:{"href":'mailto:' + _vm.value}},[_vm._t("default")],2):(_vm.type === 'fileList')?_c('router-link',{staticClass:"text-decoration-none text--black",attrs:{"to":{
		name: 'event-actions-by-id',
		params: {
			eventId: _vm.eventId,
			actionId: _vm.actionId,
		},
		query: {
			title: _vm.action.action_name,
		},
	}}},[_vm._t("default")],2):(_vm.type === 'linkList')?_c('router-link',{staticClass:"text-decoration-none text--black",attrs:{"to":{
		name: 'event-links-by-id',
		params: {
			eventId: _vm.eventId,
			actionId: _vm.actionId,
		},
		query: {
			title: _vm.action.action_name,
		},
	}}},[_vm._t("default")],2):(_vm.type === 'deepLink')?_c('a',{staticClass:"text-decoration-none",attrs:{"target":"_self"}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }